export default __webpack_public_path__ + "static/media/FS-LAPTOP-HOME.aee536f6.png";